import Vue from 'vue'
import { S, G, M, A } from './types'
import Vuex, { RootState, Getters, Mutations, Actions, ExStore } from 'vuex'
import user from '@/store/user'
import patient from '@/store/patient'
import worker from '@/store/worker'
import call from '@/store/call'
import schedule from '@/store/schedule'
import scheduleType from '@/store/scheduleType'
import videoCallRoom from '@/store/videoCallRoom'
import watchingWorker from '@/store/watchingWorker'
import scheduleComment from '@/store/scheduleComment'
import team from '@/store/team'
import message from '@/store/message'
import occupation from '@/store/occupation'
import appSettings from '@/store/appSettings'
import dispensation from '@/store/dispensation'
import labotest from '@/store/labotest'
import medicine from '@/store/medicine'
import preInputs from '@/store/preInputs'
import image from '@/store/image'
import dicom from '@/store/dicom'
import medicationInstruction from '@/store/medicationInstruction'
import onlineStatus from '@/store/onlineStatus'
import pd from '@/store/pd'
import pdSetting from '@/store/pdSetting'
import drawing from '@/store/drawing'
import hd from '@/store/hd'
import ble from '@/store/ble'
import ecg from '@/store/ecg'
import alert from '@/store/alert'
import relative from '@/store/relative'

Vue.use(Vuex)

/* -------------------------------------------------------------------------- */

export const rootState = (): S => ({})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {}

/* -------------------------------------------------------------------------- */

export default new Vuex.Store({
  state: rootState() as RootState,
  getters,
  mutations,
  actions,
  modules: {
    //   [module name]: module,
    //   ** maybe
    //   module,
    user,
    patient,
    worker,
    call,
    schedule,
    videoCallRoom,
    scheduleComment,
    team,
    scheduleType,
    watchingWorker,
    message,
    occupation,
    appSettings,
    dispensation,
    labotest,
    medicine,
    preInputs,
    image,
    dicom,
    medicationInstruction,
    onlineStatus,
    pd,
    pdSetting,
    drawing,
    hd,
    ble,
    ecg,
    alert,
    relative
  }
}) as ExStore
